import { render, staticRenderFns } from "./HistoryContent.vue?vue&type=template&id=1a00cde2&"
import script from "./HistoryContent.vue?vue&type=script&lang=js&"
export * from "./HistoryContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports